import { createPinia } from 'pinia';
import { createORM } from 'pinia-orm';

function initStore() {
  const pinia = createPinia();
  pinia.use(createORM());
  return pinia;
}

export { initStore };
